import { setSafeInnerHTML } from './htmlSecurityModule.js';

export function renderCurrentViewByName(currentView, renderers = {}) {
  switch (currentView) {
    case 'shelf':
      renderers.renderBookshelf?.();
      break;
    case 'booklist':
      renderers.renderBooklistView?.();
      break;
    case 'thoughts':
      renderers.renderThoughtsView?.();
      break;
    case 'highlights':
      renderers.renderHighlights?.();
      break;
    case 'essays':
      renderers.renderEssays?.();
      break;
    case 'music':
      renderers.renderMusic?.();
      break;
    case 'admin':
      renderers.renderAdmin?.();
      break;
  }
}

export function ensureMusicViewInitialized({ state, ensureMusicPlayerReady, showToast }) {
  if (state?.music?.initialized) return;
  ensureMusicPlayerReady()
    .catch(() => {
      showToast?.('音乐模块加载失败');
    });
}

export function renderBooklistViewWithLazyInit({
  booklistModuleApi,
  ensureBooklistModuleReady,
  rerender,
  showToast
}) {
  if (!booklistModuleApi || !booklistModuleApi.isBooklistModuleInitialized?.()) {
    ensureBooklistModuleReady()
      .then(() => {
        rerender?.();
      })
      .catch(() => {
        showToast?.('书单模块加载失败');
      });
    return;
  }

  booklistModuleApi.renderBooklistView?.();
}

export function renderThoughtsViewWithLazyInit({
  state,
  elements,
  thoughtsModuleApi,
  thoughtsModuleEventsBound,
  ensureThoughtsModuleReady,
  rerender,
  getThoughtsCallbacks,
  syncThoughtsScrollbarGutter,
  requestAnimationFrameFn = requestAnimationFrame,
  showToast
}) {
  if (!thoughtsModuleApi || !thoughtsModuleEventsBound) {
    if (state.currentView === 'thoughts') {
      if (elements.emptyThoughts) elements.emptyThoughts.style.display = 'none';
      setSafeInnerHTML(elements.thoughtsList, '<div class="loading"><div class="loading-spinner"></div></div>', { profile: 'app' });
    }

    ensureThoughtsModuleReady()
      .then(() => {
        if (state.currentView === 'thoughts') {
          rerender?.();
        }
      })
      .catch(() => {
        if (state.currentView === 'thoughts') {
          showToast?.('思索模块加载失败');
        }
      });
    return;
  }

  const callbacks = getThoughtsCallbacks();
  thoughtsModuleApi.initThoughtsViewSwitcher(elements, state, callbacks);
  thoughtsModuleApi.renderThoughts(elements, state, callbacks);
  requestAnimationFrameFn(() => {
    syncThoughtsScrollbarGutter?.();
  });
}

export function renderHighlightsViewWithLazyInit({
  state,
  highlightsModuleApi,
  highlightsModuleEventsBound,
  ensureHighlightsModuleReady,
  rerender,
  showToast
}) {
  if (!highlightsModuleApi || !highlightsModuleEventsBound) {
    ensureHighlightsModuleReady()
      .then(() => {
        if (state.currentView === 'highlights') {
          rerender?.();
        }
      })
      .catch(() => {
        if (state.currentView === 'highlights') {
          showToast?.('涂鸦模块加载失败');
        }
      });
    return;
  }

  highlightsModuleApi.renderHighlightsView?.();
}
